import React, { useEffect, useRef, useState } from 'react'
import ReactPortal from 'Components/ReactPortal/ReactPortal'
import useDebounce from 'CustomHooks/useDebounce'
import api from 'http'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage'
import { motion } from 'framer-motion';
import { BACKDROP_VARIANTS } from 'Common/Constants'
import { GrClose } from 'react-icons/gr'
import SlidingTabs from 'Common/SlidingTabs/SlidingTabs'
import Skeleton from 'Components/skeleton/Skeleton'
import Pagination from 'Common/CusomReactGrid/Pagination'
import RecentSearches from './RecentSearches'
import NoSearchFound from 'SVGS/NoSearchFound'
import { useDispatch } from 'react-redux'
import { activeMainTab, addPatient, swtichTab } from 'Redux/TabsSlice/TabsSlice'
import GlobalSearchItem from './GlobalSearchItem'
import { FiSearch } from "react-icons/fi";
import SearchIcon from 'SVGS/SearchIcon'
import { patientPaymentTabs } from 'MainTabs/PatientPayments/PatientPayments'
import { toast } from 'react-toastify'
import GlobalNavigation from 'Common/GlobalNavigationObj'

const initialParamModel = {
    perPage: 20,
    pageNo: 1,
    totalCount: 0,
};
const GlobalSearchPopup = ({ onClose, isVisible }) => {
    const searchTabs = ["All", "Patient", "Claim", "Payment"]
    const [inputValue, setInputValue] = useState("")
    const [searchList, setSearchList] = useState([])
    const [selectedRowNumber, setSelectedRowNumber] = useState(0);
    const [isLoading, setIsLoading] = useState(false)
    const [searchType, setSearchType] = useState(searchTabs[0]);
    const [pagination, setPagination] = useState(initialParamModel);
  
    
    const inputRef = useRef(null);

    const debouncedSearchTerm = useDebounce(inputValue, 500);
    const dispatch = useDispatch();

    const handleSearchType = (index) => {
        setSearchType(index);
    };

    // ========================= ON KEY DOWN PRESSED INPUT FIELD======================
    const onKeyDownPressed = async (e) => {
        if (e.keyCode === 13) {
            // User pressed the ENTER key
            if (searchList.length > 0) {
                gotoSearchModule(searchList[selectedRowNumber])

            }
        } else if (e.keyCode === 38) {
            // if user presses the UP
            if (selectedRowNumber > 0) {
                setSelectedRowNumber((prevSelectedRow) => prevSelectedRow - 1);
                const selectedRowUP = selectedRowNumber - 1
                var elemUp = document.getElementById(`globalSearchInput_${selectedRowUP}`);
                elemUp.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
            }
        } else if (e.keyCode === 40) {
            // IF USER PRESSES DOWN KEY
            if (selectedRowNumber < searchList.length - 1) {
                setSelectedRowNumber((prevSelectedRow) => prevSelectedRow + 1);
                const selectedRowDown = selectedRowNumber + 1
                var elemDown = document.getElementById(`globalSearchInput_${selectedRowDown}`);
                elemDown.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'start',
                });
            }
        } else if (e.keyCode === 27) {
            // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
            onClose()
        } else if (e.keyCode === 9) {
            // IF USER PRESSES THE TAB BUTTON
            // if (tableData.length > 0) {
            //     props.getSelectedData(tableData[selectedRowNumber]);
            //     setshowTable(false);
            // }
        }
        else if (e.keyCode === 8) {
            // IF USER PRESSES THE BACKSPACE BUTTON
            // setSelectedRowNumber(0)
        }
    };


    // ***************** PAGINATION FUNCTION START *********************
    const handlePageChange = (pageno) => {
        setPagination((prev) => (
            { ...prev, pageNo: pageno }
        ));
    };

    const handlePerRowsChange = (rowsPerPage, pageno) => {
        setPagination((prev) => (
            { ...prev, pageNo: pageno, perPage: rowsPerPage }
        ));
    };
    // ***************** PAGINATION FUNCTION END *********************

    const gotoSearchModule = (s) => {
        switch (s.source) {
            case "Patient":
                {
                    const patientObj = {
                        active: true,
                        id: s.id,
                        accountNum: s.accountNumber,
                        subTab: "Overview",
                        name: s.label,
                        unsavedChanges: false,
                        insuranceData: { status: false, editMode: false }
                    }
                    dispatch(addPatient(patientObj))
                    break;
                }
            case "Claim":
                {

                    const visitobj = {
                        visitId: s.id,
                        patientId: s.extraId
                    }
                    dispatch(swtichTab({ parentName: "charges", subTabName: "claim", subTabData: visitobj }));
                    break;
                }
            case "Payment":
                {
                    if (s.sourceType === "Patient") {
                        const patientPaymentKey = GlobalNavigation.find(tab => tab.name === "patient payments")?.key;
                        const patientPaymentObj = {
                            key: patientPaymentKey,
                            name: "patient payments",
                            activeTab: patientPaymentTabs.Payments,
                            right: true,
                            title: "Patient Payments",
                            data: s.id
                        }
                        dispatch(activeMainTab(patientPaymentObj));
                    } else {
                        toast.info("Exciting new feature coming your way soon.😎💡")
                    }


                    break;
                }
            default:
            // code block
        }
        onClose()

    }
     // **************************** RECENT SEARCHES FUNCTION START ***************
     const getRecentSearch = (s) => {
        setInputValue(s)
    }
 
    // **************************** RECENT SEARCHES FUNCTION END ***************

    // **************************** PASTE HANDLER FUNCTION START ***************
    const handlePaste = (e) => {
        e.preventDefault();
        const pastedText = e.clipboardData.getData('text');
        setInputValue(pastedText.trim());
    };
    // **************************** PASTE HANDLER FUNCTION END ***************

    useEffect(() => {
        if (isVisible) {
            // Adding a slight delay ensures the DOM updates before focusing
            const timeout = setTimeout(() => {
                inputRef.current?.focus();
            }, 0);
            return () => clearTimeout(timeout); // Cleanup timeout if component unmounts
        }
    }, [isVisible]);

    useEffect(() => {
        if (debouncedSearchTerm.length >= 2) {
            (async () => {
                try {
                    setIsLoading(true)
                    const response = await api.get(` ${process.env.REACT_APP_TC_PMS}/api/SuperSearch/FindGlobalSuperSearch/${searchType}/${debouncedSearchTerm}/${pagination.pageNo}/${pagination.perPage}`);
                    setIsLoading(false)
                    setSearchList(response.data.dataModel.data)
                    setPagination((prev) => ({
                        ...prev,
                        totalCount: response.data.dataModel.totalCount
                    }))
                    localStorage.setItem('recentSearches', JSON.stringify([...new Set([...JSON.parse(localStorage.getItem('recentSearches') || '[]'), debouncedSearchTerm])].slice(-10)));
                } catch (error) {
                    setIsLoading(false)
                    ErrorHandlingMessage(error)
                    setSearchList([])
                }
            })();
        }
        else {
            setSearchList([])
        }
        setSelectedRowNumber(0)
    }, [debouncedSearchTerm, searchType, pagination.pageNo, pagination.perPage])

 

    const popupVariants = {
        hidden: { y: "-100%", opacity: 0 }, // Slide in from the top
        visible: { y: 0, opacity: 1 },      // Fully visible at the center
        exit: { y: "-100%", opacity: 0 },
    };


    return (
        <ReactPortal wrapperId="GlobalSearchPopup">
            {isVisible && (
                <motion.div className="fixed z-[9] flex justify-center inset-0 transition-opacity bg-gray-500 bg-opacity-75" initial="hidden" animate="visible" exit="exit" variants={BACKDROP_VARIANTS} transition={{ duration: 0.3 }}
                // onClick={onClose}
                >
                    <motion.div className={`overflow-y-auto overflow-x-hidden fixed top-0 mt-2 w-1/2 h-full outline-none z-[10]`} initial="hidden" animate="visible" exit="exit" variants={popupVariants} transition={{ type: 'spring', stiffness: 300, damping: 30 }}  >
                        <div className="pointer-events-autorelative flex justify-between  w-full flex-col overflow-hidden rounded-md border-none bg-[#F4F5F7] bg-clip-padding shadow-lg outline-none dark:bg-neutral-600">
                            <div className="relative  bg-[#F4F5F7] overflow-y-auto  ">
                                <div className='p-4 bg-white rounded'>
                                    <div className='relative mb-4'>
                                        <FiSearch className='absolute top-2 left-3 text-secondaryLight' size={20} />
                                        <input onKeyDown={onKeyDownPressed} onPaste={handlePaste} ref={inputRef} value={inputValue} onChange={(e) => setInputValue(e.target.value)} className='px-12 py-2 w-full text-xl font-semibold border-b outline-none placeholder:text-xl placeholder:font-semibold' placeholder="Search patients, claims or payments" />
                                        <GrClose className='absolute top-2 right-3 cursor-pointer' onClick={() => onClose(false)} size={20} />
                                    </div>
                                    <SlidingTabs activeTab={searchType} extraClass="mb-4 mx-2 font-semibold text-sm" >
                                        {searchTabs.map((name) => {
                                            return (
                                                <li key={name} value={name} className={name === searchType ? "activePatientSubTab" : "text-secondaryLight"}><button onClick={() => handleSearchType(name)}>{name}{name === "All" ? "" : "s"}</button></li>
                                            );
                                        })}
                                    </SlidingTabs>

                                    {JSON.parse(localStorage.getItem('recentSearches') || '[]').length > 0 && <RecentSearches getRecentSearch={getRecentSearch} />}
                                    <div className=" overflow-y-auto min-h-[50vh] max-h-[63vh]">
                                        {!inputValue && (<div className='h-[264px]  flex flex-col justify-center items-center'>
                                            <SearchIcon className="mb-3" />
                                            <span className='mb-1 text-xl font-semibold'>Search</span>
                                            <h1 className='text-sm text-secondaryLight'>Search for patients, claims or payments</h1>
                                        </div>)}
                                        {isLoading ? (
                                            [...Array(10)].map((_, i) => (
                                                <div className='flex gap-5 items-center px-4 mb-5'>
                                                    <div>
                                                        <Skeleton extraClass="rounded-sm h-[16px] w-[16px] " />
                                                    </div>
                                                    <div className='flex flex-col w-[95%] gap-2 animate-pulse'>
                                                        <Skeleton extraClass=" rounded-sm h-[10px] w-full " />
                                                        <Skeleton extraClass=" rounded-sm h-[10px] w-full " />

                                                    </div>
                                                </div>
                                            ))

                                        ) : debouncedSearchTerm && searchList.length === 0 ? (
                                            <div className='flex justify-center items-center h-72'>
                                                <div className='flex flex-col items-center mx-auto text-center'>
                                                    <NoSearchFound />
                                                    <h1 className='font-semibold'>No results found</h1>
                                                    <small className='text-secondaryLight'>Try using different keywords</small>
                                                </div>
                                            </div>
                                        ) :
                                            searchList.map((list, index) => {
                                                let selected = false;
                                                if (index === selectedRowNumber) {
                                                    selected = true;
                                                }
                                                return (

                                                    <GlobalSearchItem key={index} list={list} onClose={onClose} index={index} selected={selected} gotoSearchModule={gotoSearchModule} />

                                                )
                                            })}
                                    </div>
                                    <div>
                                        {searchList.length > 0 && <Pagination handlePerRowsChange={handlePerRowsChange} handlePageChange={handlePageChange} pagination={pagination} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </motion.div>
            )}
        </ReactPortal>
    )
}

export default GlobalSearchPopup

